/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col } from 'antd';

import { useCreateGameNotification, useUpdateGameNotification } from '@api/hooks';
import { NO_MARGIN_BOTTOM } from '@constants';
import { Block, Button } from '@atoms';
import { TextField } from '@molecules';
import { Form } from '@organisms';

import { FORM_FIELD, INITIAL_VALUES } from './constants';

const GameNotificationForm = ({ isFetching = false, initialValues: initData, id }) => {
  const [form] = Form.useForm(FORM_FIELD);
  const [createGameNotificationMutation, createQuery] = useCreateGameNotification({});
  const [updateGameNotificationMutation, updateQuery] = useUpdateGameNotification({});

  const initialValues = React.useMemo(
    () => ({
      ...form.deserialize(initData?.id ? initData : INITIAL_VALUES),
    }),
    [initData, form],
  );

  const onFinish = React.useCallback(
    (values) => {
      const body = {
        id,
        values,
        hasBeenCreated: initialValues?.id ? updateQuery.isSuccess : createQuery.isSuccess,
      };
      if (initialValues?.id) updateGameNotificationMutation(body);
      else createGameNotificationMutation(body);
    },
    [initialValues, id, createGameNotificationMutation, updateGameNotificationMutation, updateQuery, createQuery],
  );

  const handleCancel = React.useCallback(() => {
    form.resetFields();
  }, [form]);

  return (
    <Form onSerializedFinish={onFinish} initialValues={initialValues} layout="vertical" form={form}>
      <Row gutter={[30, 30]}>
        <Col span={24}>
          <Block spaced>
            <h2>Add a notification</h2>
            <TextField {...FORM_FIELD.NOTIFICATION_TEXT} />
            <TextField {...FORM_FIELD.NOTIFICATION_BUTTON_TEXT} />
            <TextField {...FORM_FIELD.NOTIFICATION_URL} />
            <Row align="middle" gutter={20}>
              <Col flex="0 0 auto">
                <Button
                  loading={updateQuery.isLoading || createQuery.isLoading}
                  disabled={isFetching}
                  htmlType="submit"
                  type="primary"
                  key="submit"
                >
                  SAVE
                </Button>
              </Col>

              <Col flex="0 0 auto">
                <Button htmlType="button" key="submit" onClick={handleCancel}>
                  RESET
                </Button>
              </Col>
            </Row>
          </Block>
        </Col>
      </Row>
    </Form>
  );
};

GameNotificationForm.useForm = () => Form.useForm(FORM_FIELD);

export default GameNotificationForm;
